import React, { useContext } from 'react';
import Faq from './Faq';
import ConfigContext from '../../../contexts/ConfigContext';

const getTacoFaqQuestions = (cityName, siteTitle, vehicleType) => [
  {
    question: `How much does taco food ${vehicleType} catering cost in ${cityName}?`,
    answer: `Pricing depends on guest count, menu, service style, event length, and location. Send your event details to compare actual quotes from available ${vehicleType}s.`
  },
  {
    question: `What types of tacos can a taco food ${vehicleType} serve at my event?`,
    answer: `Street tacos like carne asada and al pastor, Baja-style fish tacos, vegetarian and vegan tacos, and fusion options. Many ${vehicleType}s make their own tortillas and salsas and can run a build-your-own taco bar.`
  },
  {
    question: `Are taco food ${vehicleType}s good for weddings and large events?`,
    answer: `Yes. Tacos are quick to serve, easy to eat standing up, and simple to adapt for dietary needs, which is why they show up at receptions, rehearsal dinners, and late-night snacks. Ask each ${vehicleType} how many guests it can serve per hour.`
  },
  {
    question: `Can taco food ${vehicleType}s accommodate vegetarian, vegan, or gluten-free diets?`,
    answer: `Most offer vegetarian and vegan tacos, and corn tortillas make gluten-free straightforward. Note dietary needs in your request so the ${vehicleType}s that quote can plan for them.`
  },
  {
    question: `How far in advance should I book a taco food ${vehicleType} for catering?`,
    answer: `Earlier is better for weekends, large events, and peak seasons. If your date is close, send the request anyway. Availability varies by ${vehicleType}.`
  }
];

function TacoFaq() {
  const { city_name, site_title, vehicle_type } = useContext(ConfigContext);
  const vehicleType = vehicle_type.toLowerCase();

  const questions = getTacoFaqQuestions(city_name, site_title, vehicleType);

  return (
    <Faq questions={questions} />
  );
}

export default TacoFaq;
